import { LoginClearPreloadedData } from '../login/types';
import * as Bixby from './../../core';

export interface PortfolioState {
  portfolio?: Bixby.Models.CompanyPortfolio[];
  isLoading: boolean;
  isSavingClientEbitda: boolean;
  error?: Bixby.Models.BixbyError;
  currentCompany?: Bixby.Models.Company;
  financialStatements: Bixby.Models.FinancialStatement[];
  isCreatingDealNote: boolean;
  isLoadingDealNotes: boolean;
  dealNotes?: Bixby.Models.DealNote[];
}

export const COMPANY_LOADING = 'COMPANY_LOADING';
export const COMPANY_SUCCESS = 'COMPANY_SUCCESS';
export const COMPANY_FAILURE = 'COMPANY_FAILURE';
export const COMPANY_FINANCIAL_LOADING = 'COMPANY_FINANCIAL_LOADING';
export const COMPANY_FINANCIAL_SUCCESS = 'COMPANY_FINANCIAL_SUCCESS';
export const COMPANY_FINANCIAL_FAILURE = 'COMPANY_FINANCIAL_FAILURE';
export const PORTFOLIO_LOADING = 'PORTFOLIO_LOADING';
export const PORTFOLIO_SUCCESS = 'PORTFOLIO_SUCCESS';
export const PORTFOLIO_FAILURE = 'PORTFOLIO_FAILURE';
export const SET_ALERTS_ENABLED_SUCCESS = 'SET_ALERTS_ENABLED_SUCCESS';
export const SET_ALERTS_ENABLED_FAILURE = 'SET_ALERTS_ENABLED_FAILURE';
export const SAVE_CLIENT_EBITDA_LOADING = 'SAVE_CLIENT_EBITDA_LOADING';
export const SAVE_CLIENT_EBITDA_SUCCESS = 'SAVE_CLIENT_EBITDA_SUCCESS';
export const SAVE_CLIENT_EBITDA_FAILURE = 'SAVE_CLIENT_EBITDA_FAILURE';
export const CREATE_DEAL_NOTE_LOADING = 'CREATE_DEAL_NOTE_LOADING';
export const CREATE_DEAL_NOTE_SUCCESS = 'CREATE_DEAL_NOTE_SUCCESS';
export const CREATE_DEAL_NOTE_FAILURE = 'CREATE_DEAL_NOTE_FAILURE';
export const DEAL_NOTES_LOADING = 'DEAL_NOTES_LOADING';
export const DEAL_NOTES_SUCCESS = 'DEAL_NOTES_SUCCESS';
export const DEAL_NOTES_FAILURE = 'DEAL_NOTES_FAILURE';

interface CompanyLoading extends Bixby.Models.BixbyAction<undefined, typeof COMPANY_LOADING> {
  type: typeof COMPANY_LOADING;
}

interface CompanySuccess extends Bixby.Models.BixbyAction<Bixby.Models.Company, typeof COMPANY_SUCCESS> {
  type: typeof COMPANY_SUCCESS;
  payload: Bixby.Models.Company;
}

interface CompanyFailure extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof COMPANY_FAILURE> {
  type: typeof COMPANY_FAILURE;
  payload: Bixby.Models.BixbyError;
}

interface CompanyFinancialLoading
  extends Bixby.Models.BixbyAction<Bixby.Models.FinancialStatementLoading, typeof COMPANY_FINANCIAL_LOADING> {
  type: typeof COMPANY_FINANCIAL_LOADING;
  payload: Bixby.Models.FinancialStatementLoading;
}

interface CompanyFinancialSuccess
  extends Bixby.Models.BixbyAction<Bixby.Models.FinancialStatement, typeof COMPANY_FINANCIAL_SUCCESS> {
  type: typeof COMPANY_FINANCIAL_SUCCESS;
  payload: Bixby.Models.FinancialStatement;
}

interface CompanyFinancialFailure
  extends Bixby.Models.BixbyAction<Bixby.Models.FinancialStatementError, typeof COMPANY_FINANCIAL_FAILURE> {
  type: typeof COMPANY_FINANCIAL_FAILURE;
  payload: Bixby.Models.FinancialStatementError;
}

interface PortfolioLoading extends Bixby.Models.BixbyAction<undefined, typeof PORTFOLIO_LOADING> {
  type: typeof PORTFOLIO_LOADING;
}

interface PortfolioSuccess extends Bixby.Models.BixbyAction<Bixby.Models.CompanyPortfolio[], typeof PORTFOLIO_SUCCESS> {
  type: typeof PORTFOLIO_SUCCESS;
  payload: Bixby.Models.CompanyPortfolio[];
}

interface PortfolioFailure extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof PORTFOLIO_FAILURE> {
  type: typeof PORTFOLIO_FAILURE;
  payload: Bixby.Models.BixbyError;
}

interface SaveClientEbitdaLoading extends Bixby.Models.BixbyAction<undefined, typeof SAVE_CLIENT_EBITDA_LOADING> {
  type: typeof SAVE_CLIENT_EBITDA_LOADING;
}

interface SaveClientEbitdaSuccess
  extends Bixby.Models.BixbyAction<Bixby.Models.Company, typeof SAVE_CLIENT_EBITDA_SUCCESS> {
  type: typeof SAVE_CLIENT_EBITDA_SUCCESS;
  payload: Bixby.Models.Company;
}

interface SaveClientEbitdaFailure
  extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof SAVE_CLIENT_EBITDA_FAILURE> {
  type: typeof SAVE_CLIENT_EBITDA_FAILURE;
  payload: Bixby.Models.BixbyError;
}

interface CreateDealNoteLoading extends Bixby.Models.BixbyAction<undefined, typeof CREATE_DEAL_NOTE_LOADING> {
  type: typeof CREATE_DEAL_NOTE_LOADING;
}

interface CreateDealNoteSuccess
  extends Bixby.Models.BixbyAction<Bixby.Models.DealNote[], typeof CREATE_DEAL_NOTE_SUCCESS> {
  type: typeof CREATE_DEAL_NOTE_SUCCESS;
  payload: Bixby.Models.DealNote[];
}

interface CreateDealNoteFailure
  extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof CREATE_DEAL_NOTE_FAILURE> {
  type: typeof CREATE_DEAL_NOTE_FAILURE;
  payload: Bixby.Models.BixbyError;
}

interface DealNotesLoading extends Bixby.Models.BixbyAction<undefined, typeof DEAL_NOTES_LOADING> {
  type: typeof DEAL_NOTES_LOADING;
}

interface DealNotesSuccess extends Bixby.Models.BixbyAction<Bixby.Models.DealNote[], typeof DEAL_NOTES_SUCCESS> {
  type: typeof DEAL_NOTES_SUCCESS;
  payload: Bixby.Models.DealNote[];
}

interface DealNotesFailure extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof DEAL_NOTES_FAILURE> {
  type: typeof DEAL_NOTES_FAILURE;
  payload: Bixby.Models.BixbyError;
}

interface SetAlertsEnabledSuccess extends Bixby.Models.BixbyAction<string, typeof SET_ALERTS_ENABLED_SUCCESS> {
  type: typeof SET_ALERTS_ENABLED_SUCCESS;
  payload: string;
}

interface SetAlertsEnabledFailure extends Bixby.Models.BixbyAction<string, typeof SET_ALERTS_ENABLED_FAILURE> {
  type: typeof SET_ALERTS_ENABLED_FAILURE;
  payload: string;
}

export type PortfolioActionTypes =
  | PortfolioLoading
  | PortfolioSuccess
  | PortfolioFailure
  | CompanyLoading
  | CompanyFailure
  | CompanySuccess
  | CompanyFinancialLoading
  | CompanyFinancialSuccess
  | CompanyFinancialFailure
  | SaveClientEbitdaLoading
  | SaveClientEbitdaSuccess
  | SaveClientEbitdaFailure
  | CreateDealNoteLoading
  | CreateDealNoteSuccess
  | CreateDealNoteFailure
  | DealNotesLoading
  | DealNotesSuccess
  | DealNotesFailure
  | LoginClearPreloadedData
  | SetAlertsEnabledSuccess
  | SetAlertsEnabledFailure;
